import React from "react";
import { useTranslation } from 'react-i18next';
import LightEmperador from "../Components/quarries/LightEmperador";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function LightEmperadorPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = productSeoData[currentLang]?.lightEmperador || productSeoData.en.lightEmperador;

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/lightemperador"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <LightEmperador />
    </>
  );
}

export default LightEmperadorPage;
